export default {
  getByRenterId: (state) => (renterId) => {
    return state.availableByRenterId[renterId]
  }
}
